import {absoluteUrl, SITE_URL} from './seoConstants'
import type {FaqEntry} from './seoTypes'

// schema.org SoftwareApplication describing Ecranify — used on tool/comparison
// pages so search engines understand the product (freemium web app).
export const softwareApplicationSchema = (): object => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Ecranify',
  applicationCategory: 'DesignApplication',
  operatingSystem: 'Web browser',
  url: SITE_URL,
  description:
    'Browser-based tool for creating 3D App Store and Google Play screenshots and device mockups. Free to start; pay only when you export.',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    description: 'Free to use; pay per export with credit packs.',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Small Water s. r. o.',
    url: SITE_URL,
  },
})

// schema.org FAQPage from a list of Q&A pairs — powers "People also ask" style
// rich results on any page that renders an FAQ section.
export const faqSchema = (faq: readonly FaqEntry[]): object => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faq.map((entry) => ({
    '@type': 'Question',
    name: entry.q,
    acceptedAnswer: {'@type': 'Answer', text: entry.a},
  })),
})

// schema.org Article for guide pages.
export const articleSchema = (title: string, description: string, canonicalPath: string): object => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  url: absoluteUrl(canonicalPath),
  author: {'@type': 'Organization', name: 'Ecranify'},
  publisher: {
    '@type': 'Organization',
    name: 'Small Water s. r. o.',
    url: SITE_URL,
  },
})
